import * as actionTypes from './actionTypes';

import axios from '../../axios-orders';



export const fetchDriversSuccess= (drivers)=>{
    
    return {
      
      type: actionTypes.FETCH_DRIVERS_SUCCESS,
      drivers: drivers
  };  
}

export const fetchDriversFail= (error)=>{
    
    return {
      
      type: actionTypes.FETCH_DRIVERS_FAIL,
      error: error
  };  
}

export const fetchDriversStart= ()=>{
    
    return {
      
      type: actionTypes.FETCH_DRIVERS_START
  }; 
}
    


export const fetchDrivers=(token, userId)=>{
 

 return dispatch=>{
     
     dispatch(fetchDriversStart());
     
     //const queryParams ='?auth='+token+'&orderBy="userId"&equalTo="'+userId+'"'; // this didn't work for some reason but gave an error. I copied the code above from the instructor
     
     axios.get('/drivers.json').then(response=>{//token comes from orders.js. Other way to get access to this state property is by getState() but that wasn't not recommended by the instructor
            
            const fetchedDrivers=[];
            
            for(let key in response.data){
                
                fetchedDrivers.push({...response.data[key], id: key});
            }
         
         localStorage.setItem('fetched', true);
             dispatch(fetchDriversSuccess(fetchedDrivers));
        }).catch(error=>{
            
            dispatch(fetchDriversFail(error));
        })
     
 }  
 
};

//export const checkStatus=(value)=>{
//    
//    return dispatch=>{
//    
//    
//    
//         axios.get('/drivers.json').then(response=>{//token comes from orders.js. Other way to get access to this state property is by getState() but that wasn't not recommended by the instructor
//            
//          
//                    
//                localStorage.setItem('existing', value);
//                
//              
//                
//                dispatch(setExistingUser(value)); //this isn't actually needed in case you just check if there is an item in localStorage called "existing". Using Redux states to determine wether or not some Routes are accesible and Navlinks shown isn't the best way in case the user refreses the site for some reason, in which case the states' reset to their defaults.
//            
//             
//        }).catch(error=>{
//            
//            dispatch(fetchDriversFail(error));
//        })
//        
//    }
//}

export const existingStatusUpdate=(userId)=>{
    
    return dispatch=>{
        
         axios.get('/drivers.json').then(response=>{
                
                
                let existingUser=response.data;
                
                let userIds=[];
                
              
                
                for(let key in existingUser){
                    
                    userIds.push(existingUser[key].userId);
                }
                
              
                
                const checkRegistration=userIds.filter(user=> {
                    
                
                    
                    return user === userId;
                })
                
            
                
                let registeredUser=false;
                
                if(checkRegistration.length >= 1){
                    
                    
                    registeredUser=true;
                    
                 
                    dispatch(setExistingUser(registeredUser));
                }
                
                dispatch(setExistingUser(registeredUser));
                
                
            }).catch(error=>{
            
            dispatch(fetchDriversFail(error));
        })
    }
}


export const setExistingUser= value=>{
    
    return {
      
      type: actionTypes.SET_STATUS,
      value: value
  };  
}


// WEBPACK FOOTER //
// ./src/store/actions/fetch.js